"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Estoque = void 0;
var bson_1 = require("bson");
var Estoque = /** @class */ (function () {
    function Estoque() {
        this._id = new bson_1.ObjectId();
        this.GRADE = '';
        this.DATA_REM = '';
        this.CD_TIPO = 0;
        this.CD_CATEGORIA = '';
        this.QUANTIDADE = 0;
        this.UN = '';
        this.dataOriginal = '';
        this.CD_MATERIAL = '';
        this.ctgResumida = '';
        this.CHAVE_COMP = { material: '', grade: '', data: '' };
        this.CHAVE_COMP_TIPO = { material: '', grade: '', tipo: 0 };
    }
    return Estoque;
}());
exports.Estoque = Estoque;
//# sourceMappingURL=Estoque.js.map